module.exports = __webpack_public_path__ + "static/media/cabinet-filing.f1b9de83.svg";